export default "__VITE_ASSET__b0879f0b__"